import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Store } from '@ngrx/store';
import { DealStatus, DealVersion } from '../../types/deal.types';
import { ManagerDealSelection } from '../../state/manager/selection/actions';
import { MuniRootReducerState } from '../../state/state';
import { ManagerGridViewModel } from '../../types/deal.viewmodel.types';

@Component({
  selector: 'muni-shared-mini-card-header',
  templateUrl: './mini-card-header.component.html',
  styleUrls: ['./mini-card-header.component.scss']
})
export class MiniCardHeaderComponent implements OnChanges {
  @Input()
  public deal: ManagerGridViewModel;

  @Input()
  public isModal = false;

  public title: string;
  public subtitle: string;

  public removeCard() {
    this.store.dispatch(new ManagerDealSelection(this.deal.id, false));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.deal) {
      const [titleRaw, ...additionalInfo] = this.descriptionLines(
        changes.deal.currentValue
      );
      const trimmedTitle = titleRaw.trim();
      this.title =
        trimmedTitle.slice(-1) === ',' ? trimmedTitle.slice(0, -1) : trimmedTitle;
      this.subtitle = additionalInfo.join(' ');
    }
  }

  public isBought() {
    return this.deal.status === DealStatus.bought;
  }

  public descriptionLines(deal: DealVersion) {
    return deal.description.split('\n');
  }

  constructor(private readonly store: Store<MuniRootReducerState>) {}
}
